var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1274"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1274"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.39570",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};